export default {
  appendChildrenToNodes (nodes, parentIdToExclude = null) {
    const map = {}
    let node = null
    const renderedNodes = []

    for (let i = 0; i < nodes.length; i++) {
      if (!nodes[i]) {
        continue
      }

      map[nodes[i].id] = i // initialize the map
    }

    for (let i = 0; i < nodes.length; i++) {
      node = nodes[i]

      if (!node) {
        continue
      }

      if (node.parent_id !== null && node.id !== parentIdToExclude) {
        // if you have dangling branches check that map[node.parentId] exists
        if (!nodes[map[node.parent_id]].children) {
          nodes[map[node.parent_id]].children = []
        }
        nodes[map[node.parent_id]].children.push(node)

      } else {
        renderedNodes.push(node)
      }
    }

    return renderedNodes
  },

  // Pull Parent Node to front of array
  unshiftParentNode (nodes, mainParentId) {
    const parentIdex = nodes.findIndex(el => {
      return el.id === mainParentId
    })

    const parent = nodes[parentIdex]

    nodes.splice(parentIdex)

    nodes.unshift(parent)

    return nodes
  },

  flatten (nodes, flattedNodes) {
    for (let index = 0; index < nodes.length; index++) {
      flattedNodes.push(nodes[index])
      if (nodes[index].children !== undefined && nodes[index].children.length > 0) {
        this.flatten(nodes[index].children, flattedNodes)
      }
    }
  },

  getIds (data) {
    const flattedTree = []

    this.flatten(data, flattedTree)

    return flattedTree.map(el => el.id)
  }
}
